import { createFileRoute } from "@tanstack/react-router";
import {
  getPointQueryOptions,
  liveChannelsQueryOptions,
} from "~/features/live/api";
import { LiveVipProfileTemplate } from "~/features/live/LiveVipProfileTemplate";
import { UserProfileSkeleton } from "~/features/profile/components/UserProfileSkeleton";
import { reviewListQueryOptions } from "~/features/review/api";

const LiveVipProfilePage = () => {
  const { userId } = Route.useParams();
  return <LiveVipProfileTemplate userId={userId} />;
};

export const Route = createFileRoute(
  "/_authenticated/profile/vip-broadcaster/$userId",
)({
  loader: async ({ context: { queryClient }, params: { userId } }) => {
    await Promise.all([
      queryClient.ensureQueryData(liveChannelsQueryOptions()),
      queryClient.ensureQueryData(getPointQueryOptions()),
      queryClient.ensureQueryData(reviewListQueryOptions(userId)),
    ]);
  },
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: UserProfileSkeleton,
  component: LiveVipProfilePage,
});
